import React from 'react';

// Styles & Assets
import styles from './InfoQuestionAdd.module.css';

// Components
import SliderCheckbox from '../../UI/SliderCheckbox/SliderCheckbox';
import { PollQuestionDispatch } from '../../../interfaces/Reducers';

// Language
import { useTranslation } from 'react-i18next';
import InputSelect from '../../UI/InputSelect/InputSelect';
import { OptionsSelect } from '../../../interfaces/Input';

const InfoQuestionAdd: React.FC<{
    questionType: number | undefined,
    dispatchQuestion: React.Dispatch<PollQuestionDispatch>
    description: string | undefined,
    parameterDescription: string | undefined,
    required: boolean | undefined
    hasTable: boolean
}> = ({ questionType, dispatchQuestion, description, parameterDescription, required, hasTable }) => {

    const { t } = useTranslation();

    const handleDescriptionChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) =>
        dispatchQuestion({ type: 'ADD_DESCRIPTION', payload: evt.target.value });

    const handleQuestionType = (option: OptionsSelect) =>
        dispatchQuestion({ type: 'SET_QUESTION_TYPE', payload: Number(option.id) });

    const handleParameterDescriptionChange = (evt: React.ChangeEvent<HTMLInputElement>) =>
        dispatchQuestion({ type: 'ADD_PARAMETER_DESCRIPTION', payload: evt.target.value });

    const handleChangeRequired = (evt: React.FormEvent<HTMLInputElement>) =>
        dispatchQuestion({ type: 'TOGGLE_REQUIRED', payload: (evt.target as HTMLInputElement).checked });

    const questionTypeOptions = [{ id: 1, name: t('multiple_option') }, { id: 3, name: t('free_text') }];
    const questionTypeName = questionTypeOptions.find(qt => qt.id === questionType)?.name;

    return (
        <>
            <div className={styles.selectType}>
                <h3 className={styles.subtitle}>{t('select_question_type')}:</h3>
                <InputSelect
                    options={questionTypeOptions}
                    value={questionTypeName || ''}
                    onChange={handleQuestionType}
                    label=''
                    simpleStyles
                />
                <div className={styles.sliderContainer}>
                    <SliderCheckbox
                        label={t('mandatory')}
                        defaultChecked={required}
                        handleChange={handleChangeRequired}
                    />
                </div>
            </div>
            <div className={styles.writeQuestion}>
                <h3 className={styles.subtitle}>{t('write_question_statement')}</h3>
                <textarea
                    onChange={handleDescriptionChange}
                    value={description}
                    placeholder={t('sleep_well') as string}>
                </textarea>
            </div>
            {hasTable &&
                <div className={styles.writeQuestion}>
                    <h3 className={styles.subtitle}>{t('enter_table_description')} ({t('optional')})</h3>
                    <input
                        type='text'
                        onChange={handleParameterDescriptionChange}
                        defaultValue={parameterDescription}
                        placeholder={t('sleep') as string}
                        className={styles.input}
                    />
                </div>
            }
        </>
    );
};

export default InfoQuestionAdd;